import React from "react";
import EditorComponent from "./EditorComponent";

const Editor = ({ label, height, required,placeholder, value, onChange = () => {} }) => {
  return (
    <div>
      <EditorComponent
        fontFamilies={["Italianno", "Orbitron", "Silkscreen", "Space+Grotesk"]}
        height={height}
        label={label}
        required={required}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default Editor;
